export const INJECTOR_KEY = Symbol('holoview.injector');
